import { Link } from 'react-router';
import styled from 'styled-components';

const StyledLinkOnline = styled(Link)`
  color: #004aad;
  font-family: inherit;
  text-decoration: none;
  cursor: pointer;
`;

export default StyledLinkOnline;
